module.exports = __webpack_public_path__ + "static/img/nawiWstecz-OFF.f4c826dd.png";